import { HTMLExtUtils } from '@ssml-editor/core';
import { SOUND_EVENT_TYPE } from './constant.js';

const soundEventHtmlToElement = ({
  element,
  children
}) => {
  const mark = HTMLExtUtils.getDataAttribute(element, "mark", "");
  const src = HTMLExtUtils.getDataAttribute(element, "src", "");
  return {
    type: SOUND_EVENT_TYPE,
    mark,
    src,
    children
  };
};

export { soundEventHtmlToElement };
//# sourceMappingURL=html-to-element.js.map
